import { Directive } from '@angular/core'
import { MatStepper } from '@angular/material'
import { StepperSelectionEvent } from '@angular/cdk/stepper'


/**
 * Fixes Angular Material horizontal stepper overflow problem.
 * @description
 * Angular Material horizontal stepper intermittently fails to resize steps correctly causing
 * them to stack. This causes an overflow effect showing white space above or bellow steps.
 *
 * @example
 * <mat-horizontal-stepper fixed> </mat-horizontal-stepper>
 *
 * @export
 * @class StepsFixedStepperDirective
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'mat-horizontal-stepper[fixed]'
})
export class StepsFixedStepperDirective {
  constructor(
    private stepper: MatStepper
  ) {
    // TODO This simply doesn't work, there doesn't seem to be a way to solve it
    this.stepper.selectionChange.subscribe((selection: StepperSelectionEvent) => {
      if (selection) {
        setTimeout(() => {
          selection.previouslySelectedStep.content.elementRef.nativeElement.parentElement.style.display = 'none'
          selection.selectedStep.content.elementRef.nativeElement.parentElement.style.display = 'block'
        }, 0)
      }
    })
  }

}
